import React, { Component } from 'react';
import './App.css';
import { Animated } from 'react-animated-css';
import { Segment, Container, Header, Icon } from 'semantic-ui-react';
import TrackVisibility from 'react-on-screen';
import NetworkBackground from './components/NetworkBackground';

import CookiePopup from './components/CookiePopup';
import Intro from './components/Intro';
import Timeline from './components/Timeline';
import Skills from './components/Skills/Skills';

class App extends Component {
    render() {
        return (
            <div>
                <CookiePopup />
                <Segment basic inverted textAlign="center" vertical className="introBackground">
                    <NetworkBackground />
                    <Container>
                        <Intro />
                    </Container>
                </Segment>
                <Segment basic textAlign="center" vertical padded="very" className="skillsSection">
                    <Container>
                        <Header as="h2" icon>
                            <TrackVisibility once>
                                {({ isVisible }) =>
                                    isVisible ? (
                                        <Animated animationIn="shake" animationInDelay={5500}>
                                            <Icon name="cubes" />
                                            Skills
                                        </Animated>
                                    ) : (
                                        ''
                                    )
                                }
                            </TrackVisibility>
                        </Header>
                        <br />
                        <br />
                        <Skills />
                    </Container>
                </Segment>
                <Segment
                    basic
                    textAlign="center"
                    vertical
                    secondary
                    padded="very"
                    className="experienceSection"
                >
                    <Container>
                        <Header as="h2" icon>
                            <TrackVisibility once>
                                {({ isVisible }) =>
                                    isVisible ? (
                                        <Animated animationIn="shake">
                                            <Icon name="briefcase" />
                                            Experience
                                        </Animated>
                                    ) : (
                                        ''
                                    )
                                }
                            </TrackVisibility>
                        </Header>

                        <br />
                        <br />

                        <Timeline />
                    </Container>
                </Segment>
                <Segment basic textAlign="center" vertical padded="very" className="footer">
                    <Container>
                        <Header />
                        <p>
                            <small />To built this page I used: <strong>React</strong>, <strong>Semantic UI</strong>, <strong>TypeIt</strong>, <strong>React Animate CSS</strong>, <strong>Webpack</strong>,
                            <strong>NPM</strong>, <strong>GIT</strong>
                        </p>
                        <p>
                            <a
                                href="https://www.iubenda.com/privacy-policy/82517659"
                                className="iubenda-white iubenda-embed "
                                title="Privacy Policy"
                            >
                                Privacy Policy
                            </a>
                        </p>
                    </Container>
                </Segment>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js